import { render, staticRenderFns } from "./BaseFormGroupArrayDraggable.vue?vue&type=template&id=f8ec1e5a"
import script from "./BaseFormGroupArrayDraggable.vue?vue&type=script&lang=js"
export * from "./BaseFormGroupArrayDraggable.vue?vue&type=script&lang=js"
import style0 from "./BaseFormGroupArrayDraggable.vue?vue&type=style&index=0&id=f8ec1e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports